import React, { useState } from 'react';
import { makeStyles } from '@seahorse/ui';



const useStyles = makeStyles({
    container: {
        display: 'grid',
        gridTemplateColumns: '1fr',
        gridTemplateRows: 'auto 1fr',
        gridRowGap: 4,
        width: '100%',
        height: '100%',
        padding: '10px',
    },
    fullscreenMessage: {
        
        width: '100%',
        height: '97%',
        justifyContent: 'center',
        alignItems: 'center', // Semi-transparent background
        color: 'white',
        fontSize: '18px',
        overflow: 'auto', // High z-index to cover other elements
    },

});

const EmgptBuddyTile = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <div>
                <h3>EMAlpha Geo FX</h3>
            </div>
            <div className={classes.fullscreenMessage}>
                <span>{"Hello! EMAlpha's Geopolitical Risk signals are based on its Multilingual AI that reads real time local media information and creates sentiment signals for various geopolitical themes. These signals can be of relevance to FX markets as real-time changes in a country's on-the-ground sentiments can effect its foreign exchange spot, forwards and volatility features. However, user is advised to exercise discretion in using this data. Reach out to"} <a href="mailto:research@emalpha.com"> research@emalpha.com </a> {"for further guidance. "}</span>
            </div>
            
            {/* <button className={classes.closeButton} onClick={onClose}>
                Close
            </button> */}
        </div>
    );
}

export default EmgptBuddyTile;
